import { Box, ChevronDownOutline, forwardRef, rem, StyleProps, Text } from '@bonusly/design-system';

import { usePrivacy } from './hooks/use-privacy';

type PrivacyButtonProps = StyleProps;

export const PrivacyButton = forwardRef<PrivacyButtonProps, 'button'>((props, ref) => {
	const { selectedOption, buttonEnabled } = usePrivacy();

	return (
		<Box
			as="button"
			type="button"
			disabled={!buttonEnabled}
			display="inline-flex"
			alignItems="center"
			gap={rem(4)}
			cursor={buttonEnabled ? 'pointer' : 'not-allowed'}
			opacity={buttonEnabled ? 1 : 0.6}
			aria-label={selectedOption.description}
			h={rem(24)}
			px={rem(6)}
			py={rem(2)}
			borderRadius={rem(8)}
			bg="secondary.bgAlpha"
			_hover={{ bg: buttonEnabled ? 'secondary.bgAlphaHover' : 'secondary.bgAlpha' }}
			_focus={{ outline: '2px solid', outlineColor: 'primary.fg', outlineOffset: '2px' }}
			data-testid="privacy-button"
			ref={ref}
			{...props}
		>
			{selectedOption.icon}
			<Text fontSize={rem(14)} color="text.soft" whiteSpace="nowrap">
				{selectedOption.label}
			</Text>
			<ChevronDownOutline boxSize={3} color="text.soft" />
		</Box>
	);
});
